import { getVouchers, getExclusiveVouchers, getUserVouchers, claimVoucher, formatVoucherDiscount, formatMaxDiscount } from '../assets/middleware-api.js';

function getVoucherMessage(targets, term) {
  if(term) return term;
  if (!targets || !targets.length) return 'This voucher has no specific target.';

  // Case 1: All items
  if (targets.length === 1 && targets[0] === "All Items") {
    return "The voucher is valid for all products.";
  }

  // Case 2: Collections
  const collections = targets.filter(t => t.startsWith("Collections:"));
  if (collections.length) {
    return `The voucher is valid for product(s) under ${collections.join(", ").replaceAll("Collections:", "collection")}.`;
  }

  // Case 3: Products
  const products = targets.filter(t => t.startsWith("Products:"));
  if (products.length) {
    // Remove the "Products:" label and leave the names
    const productNames = products.map(p => p.replace("Products:", "").trim());
    return `The voucher is valid for product(s): ${productNames.join(", ")}`;
  }

  // Fallback
  return `The voucher is valid for: ${targets.join(", ")}`;
}

function getReadableDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

function openModal(code, discount, date, minspend, message, maxdiscount = '') {
  const modalEle = document.getElementById('voucher-popup-modal');
  modalEle.querySelector('.code').textContent = code;
  modalEle.querySelector('.discount').textContent = discount;
  modalEle.querySelector('.date').textContent = date;
  modalEle.querySelector('.minSpend').textContent = minspend;
  modalEle.querySelector('.maxDiscount').textContent = maxdiscount;
  modalEle.querySelector('.maxDiscount-row').hidden = !maxdiscount;
  modalEle.querySelector('.message').textContent = message;
  modalEle.classList.remove("hidden");
}

function closeModal() {
  document.getElementById('voucher-popup-modal').classList.add("hidden");
}

function renderVouchers(container, vouchers, customerVouchers, isCustomerLoggedIn) {
  container.innerHTML = '';

  vouchers.forEach(voucher => {
    const voucherEl = document.createElement('div');
    voucherEl.className = 'oc-voucher-grid';
    voucherEl.innerHTML = `
      <div class="oc-voucher-mobile-wrapper">
        <div class="oc-voucher-wrapper">
          ${voucher.voucherStatus === 'Scheduled' ? `<div class="oc-voucher-upcoming">UPCOMING</div>` : ''}
          <img src="//alpropharmacy.com.my/cdn/shop/t/4/assets/oc_voucher-bg.png?v=184308980698068630561752591866" class="oc-voucher-bg" />
          <div class="oc-voucher-icon">
            <img src="${voucher.featuredImage?.url}" width="50" height="50" />
          </div>
          <div class="oc-voucher-info">
            <div class="oc-voucher-discount">
              ${formatVoucherDiscount(voucher)}
            </div>
            <div class="oc-voucher-label">Voucher Code:</div>
            <div class="oc-voucher-code">${voucher.voucherCode}</div>
            ${voucher.minimumPurchaseRequirements?.details?.amount ? `<div class="oc-voucher-min-spend">MIN. SPEND RM${parseFloat(voucher.minimumPurchaseRequirements?.details?.amount)?.toFixed(2)}</div>` : `<div class="oc-voucher-min-spend empty">N/A</div>`}
          </div>
        </div>
        ${voucher.startsAt && voucher.endsAt
          ? `<div class="oc-voucher-valid">VALID FROM ${getReadableDate(voucher.startsAt)} - ${getReadableDate(voucher.endsAt)}</div>`
          : '<div class="oc-voucher-valid empty">N/A</div>'}
      </div>
      <div class="oc-voucher-action-wrapper">
        ${
          voucher.usageCount !== null && voucher.usageCount === voucher.usageLimit
            ? '<span class="claim-full">Fully Redeemed</span>'
            : customerVouchers.some(v => v.voucherId === voucher.voucherId)
            ? '<span class="claim-full">Claimed</span>'
            : voucher.voucherStatus === 'Active'
            ? `<span class="claim" data-code="${voucher.voucherId}">Claim Now</span>`
            : ''
        }
        <span class="view-detail"
          data-code="${voucher.voucherCode}"
          data-discount="${formatVoucherDiscount(voucher)}"
          data-minspend="${voucher.minimumPurchaseRequirements?.details?.amount ? `RM${parseFloat(voucher.minimumPurchaseRequirements?.details?.amount)?.toFixed(2)}` : 'N/A'}"
          data-maxdiscount="${formatMaxDiscount(voucher)}"
          data-date="${voucher.startsAt && voucher.endsAt ? `${getReadableDate(voucher.startsAt)} - ${getReadableDate(voucher.endsAt)}` : 'N/A'}"
          data-message="${getVoucherMessage(voucher.discountTargets, voucher.termsAndConditions)}">
          View Details
        </span>
      </div>
    `;
    container.appendChild(voucherEl);
  });

  container.querySelectorAll('.claim').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.target.disabled = true;
      const code = e.target.getAttribute('data-code');
      if (!isCustomerLoggedIn) {
        showToast('Opps... Please login first before claim the voucher... Redirecting to login page', 'error');
        setTimeout(() => {
          window.location.href = '/account/login';
        }, 2000);
        return;
      }

      try {
        const data = await claimVoucher({ voucherId: code });
        e.target.textContent = "Claimed";
        e.target.classList.remove('claim');
        e.target.classList.add('claim-full');
        showToast('Voucher claimed successfully!', 'success');

      } catch (err) {
        if (err.message === 'Session expired. Please go back to the mobile app and tap “CAREPASS” again.') {
           showToast('Session expired. Please go back to the mobile app and tap “CAREPASS” again.', 'error');
        } else {
           showToast('Failed to claim voucher. Please try again.', 'error');
        }
        e.target.disabled = false;
      }
    }, { once: true });
  });

  container.querySelectorAll('.view-detail').forEach(btn => {
    btn.addEventListener('click', (e) => {
      const el = e.target;
      openModal(
        el.dataset.code,
        el.dataset.discount,
        el.dataset.date,
        el.dataset.minspend,
        el.dataset.message,
        el.dataset.maxdiscount
      );
    });
  });
}

async function setupVoucherSection(container) {
  const isCustomerLoggedIn = container.dataset.customerLoggedIn === 'true';
  const isExclusiveMode = container.dataset.isExclusive === 'true';
  let handpickedCodes = [];
  try {
    const raw = container.dataset.voucherCodes;
    handpickedCodes = raw ? JSON.parse(raw).filter(Boolean) : [];
  } catch {}

  try {
    let res;
    if (isExclusiveMode) {
      res = await getExclusiveVouchers();
    } else {
      res = await getVouchers(handpickedCodes);
    }

    let customerVouchers = [];
    if (isCustomerLoggedIn) {
      const customerRes = await getUserVouchers(0, 100, 'status[]=Available', handpickedCodes);
      customerVouchers = customerRes.userVouchers;
    }

    if (isCustomerLoggedIn && isExclusiveMode && res.vouchers.length === 0) {
      container.innerHTML = `
        <div style="text-align: center; padding: 40px 20px; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px;">
          <h3 style="margin-bottom: 10px;">App Exclusive</h3>
          <p style="margin-bottom: 5px;">No vouchers found at the moment</p>
        </div>
      `;
      return;
    }

    renderVouchers(container, res.vouchers, customerVouchers, isCustomerLoggedIn);

    if (typeof container._slickSetup === 'function') {
      container._slickSetup();
    }
  } catch (err) {
    if (err.message === 'Session expired. Please go back to the mobile app and tap “CAREPASS” again.') {
      container.innerHTML = `
        <div style="text-align: center; padding: 40px 20px; width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 200px;">
          <h3 style="margin-bottom: 10px;">App Exclusive</h3>
          <p style="margin-bottom: 5px;">These vouchers are exclusive to our mobile app users.</p>
          <p>Please <strong>login via the mobile app</strong> to view and claim these vouchers.</p>
        </div>
      `;
    } else {
      console.error('Failed to load vouchers:', err);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.voucher-slick');
  containers.forEach(c => setupVoucherSection(c));
});
